import React, { FC } from 'react';
import Carousel from 'react-multi-carousel';
import { LinkV2 } from '@zola/zola-ui/src/components/LinkV2';
import { MOBILE_MAX, TABLET_MIN, TABLET_MAX, DESKTOP_MIN } from '~/libs/universal/utils/device';
import cx from 'classnames';

import CarouselArrowButtonAdapter from '~/components/CarouselArrowButtonAdapter';
import { desktopOnly, tabletOnly } from '@zola/zola-ui/src/styles/emotion/mixins/responsive';

import ImgixResponsivePicture from '../ImgixResponsivePicture';
import { getBrands, getMobileBrands } from './brands';

import styles from './BrandsCarousel.module.less';

const assetPath = `${process.env.IMGIX_ASSET_PATH}/static-preauth/images/BrandsCarousel`;

const getCarouselContent = (isVariation: boolean) =>
  getBrands(isVariation).map(({ key, href, imgFile, imgAltText }) => {
    return (
      <div key={key}>
        <a href={href}>
          <ImgixResponsivePicture
            className={styles.image}
            src={`${assetPath}/${imgFile}`}
            htmlAttributes={{
              alt: imgAltText,
            }}
            breakpointWidthMap={{ 1: 364, [TABLET_MIN]: 264, [DESKTOP_MIN]: 260 }}
          />
        </a>
      </div>
    );
  });
type BrandsCarouselProps = {
  className?: string;
  isVariation?: boolean;
};
const BrandsCarousel: FC<BrandsCarouselProps> = ({ className, isVariation = false }) => {
  const responsive = {
    desktop: {
      breakpoint: { max: 10000, min: DESKTOP_MIN },
      items: 4,
      slidesToSlide: 4,
    },
    tablet: {
      breakpoint: { max: TABLET_MAX, min: TABLET_MIN },
      items: 3,
      slidesToSlide: 3,
    },
    mobile: {
      breakpoint: { max: MOBILE_MAX, min: 0 },
      items: 4,
      slidesToSlide: 4,
    },
  };

  return (
    <div className={className}>
      <section className={cx(styles.mainContainer, styles.onlyMobile)}>
        <h2 className={styles.title}> Our Store Carries Over 1,000 Top Brands</h2>
        <div className={styles.mobileImageContainer}>
          {getMobileBrands(isVariation).map(({ key, href, imgFile, imgAltText }) => {
            return (
              <div key={key} className={styles.mobileItem}>
                <a href={href} className={styles.mobileATag}>
                  <ImgixResponsivePicture
                    className={styles.image}
                    src={`${assetPath}/${imgFile}`}
                    htmlAttributes={{
                      alt: imgAltText,
                    }}
                    breakpointWidthMap={{ 1: 364, [TABLET_MIN]: 264, [DESKTOP_MIN]: 260 }}
                  />
                </a>
              </div>
            );
          })}
        </div>
        <LinkV2 arrow href="/shop/brands" className={styles.cta}>
          View All Our Brands
        </LinkV2>
      </section>
      <section className={cx(styles.mainContainer, styles.notMobile)}>
        <div className={styles.titleContainer}>
          <h2 className={styles.title}> Our Store Carries Over 1,000 Top Brands</h2>
          <LinkV2 arrow sizes="regular" href="/shop/brands" css={desktopOnly}>
            View All Our Brands
          </LinkV2>
        </div>
        <div className={styles.container}>
          <Carousel
            responsive={responsive}
            ssr
            infinite
            customLeftArrow={
              <CarouselArrowButtonAdapter
                component="button"
                direction="left"
                className={cx(
                  styles.arrow,
                  'react-multiple-carousel__arrow',
                  'react-multiple-carousel__arrow--left'
                )}
              />
            }
            customRightArrow={
              <CarouselArrowButtonAdapter
                component="button"
                direction="right"
                className={cx(
                  styles.arrow,
                  'react-multiple-carousel__arrow',
                  'react-multiple-carousel__arrow--right'
                )}
              />
            }
            swipeable
            keyBoardControl
            containerClass={styles.carousel}
          >
            {getCarouselContent(isVariation)}
          </Carousel>
          <LinkV2 arrow href="/shop/brands" className={cx(styles.cta)} css={tabletOnly}>
            View All Our Brands
          </LinkV2>
        </div>
      </section>
    </div>
  );
};

export default BrandsCarousel;
